import React, { useState } from "react";
import styles from "./scss/leftsidebar.module.scss";
import CreateDropDown from "../../chat/leftsidebar/createdropdown";
import store from "../../../context/store/store";
import { Types } from "../../../context/action/action";
import { profileDetails } from "../../../models/model";
import { useSelector } from "react-redux";


type leftsideProps = {
  mainProgram:Function;
}
type leftsideState={
isActiveTab:number;
}
export default function LeftsideBars({mainProgram}:leftsideProps) {
  const profileUserDetails:  profileDetails = useSelector((state: any) => state.profileReducer);
  
  const {isSettingTab}=profileUserDetails;
  const [leftstate, setleftstate] = useState<leftsideState>({isActiveTab:0});
  const profiletogleChange =(value:any,isset:boolean,name:any)=>{
    mainProgram(value);
    setleftstate({isActiveTab:value});
    console.log(leftstate)
    store.dispatch({
      type: Types.OPEN_SETTINGS,
      payload: {
        isSettings:isset,
        isSettingTab: name
      }
    });
  };

  
  return (
    <>
      <div className={styles.leftsidebar}>
        <div className={styles.top}>
          <CreateDropDown></CreateDropDown>
        </div>
        <p className={styles.settingsTitle}>Settings</p>
        <ul className={styles.quickLinksprofile}>
          <li className={isSettingTab === 'profile' ? styles.active :'' }
            onClick={()=>profiletogleChange(0,false,'profile')} ><span className={`icon__MyProfile ${isSettingTab === 'profile' ?'active':''}`}
            ></span>My Profile</li>
          <li className={isSettingTab === 'setting' ? styles.active :'' }
            onClick={()=>profiletogleChange(1,true,'setting')}><span className={`icon__NotifyAudio ${isSettingTab === 'setting' ?'active':''}`}></span>Notifications and audio</li>
            
          <li className={isSettingTab === 'videosetting' ? styles.active :'' }
          onClick={()=>profiletogleChange(3,true,'videosetting')}><span className={`icon__VideoMeetSettings ${isSettingTab === 'videosetting' ?'active':''}`} ></span>Video Meeting Settings</li>

           <li className={isSettingTab === 'privateappindex' ? styles.active :'' }
          onClick={()=>profiletogleChange(4 ,true,'privateappindex')}>
          <span className={` ${isSettingTab === 'privateappindex' ?'active':''}`} >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M20.25 3.00001C20.6642 3.00001 21 3.3358 21 3.75001L21 8.74997C21 9.16419 20.6642 9.49998 20.25 9.49998C19.8358 9.49998 19.5 9.16419 19.5 8.74998L19.5 5.56066L13.5303 11.5303C13.2374 11.8232 12.7626 11.8232 12.4697 11.5303L10.25 9.31066L4.28033 15.2803C3.98744 15.5732 3.51256 15.5732 3.21967 15.2803C2.92678 14.9874 2.92678 14.5126 3.21967 14.2197L9.71967 7.71967C10.0126 7.42678 10.4874 7.42677 10.7803 7.71967L13 9.93934L18.4394 4.50001L15.25 4.5C14.8358 4.5 14.5 4.16421 14.5 3.75C14.5 3.33578 14.8358 3 15.25 3L20.25 3.00001ZM14.2783 13.9754C14.5931 15.0656 13.9387 16.1991 12.8371 16.4716L12.2529 16.6161C12.208 16.9038 12.1847 17.199 12.1847 17.4998C12.1847 17.8145 12.2102 18.123 12.2593 18.4232L12.7987 18.5531C13.9112 18.8211 14.5726 19.9661 14.2487 21.0636L14.0624 21.6949C14.5016 22.0805 15.002 22.3937 15.5466 22.6165L16.0399 22.0977C16.8284 21.2685 18.1507 21.2687 18.939 22.0982L19.4377 22.623C19.9812 22.4027 20.4812 22.0925 20.9205 21.7101L20.7224 21.0242C20.4077 19.9339 21.0621 18.8005 22.1636 18.528L22.7474 18.3835C22.7923 18.0958 22.8156 17.8006 22.8156 17.4998C22.8156 17.1851 22.7901 16.8765 22.741 16.5762L22.202 16.4464C21.0895 16.1785 20.4282 15.0335 20.7521 13.9359L20.9382 13.3051C20.4991 12.9193 19.9986 12.6061 19.454 12.3833L18.9609 12.9018C18.1724 13.7311 16.8501 13.7309 16.0618 12.9013L15.563 12.3765C15.0195 12.5967 14.5195 12.9068 14.0802 13.2892L14.2783 13.9754ZM17.5001 18.9998C16.6995 18.9998 16.0505 18.3282 16.0505 17.4998C16.0505 16.6714 16.6995 15.9998 17.5001 15.9998C18.3008 15.9998 18.9498 16.6714 18.9498 17.4998C18.9498 18.3282 18.3008 18.9998 17.5001 18.9998Z" fill="#00E2A4"/>
</svg>
            
            </span>Private App</li>


         
        </ul>
      
      </div>
    </>
  );
};

